// const WP_FIXED = 160; // 200;
const PV_MODULE_GEN = 0.4; // 1 PV Module generates 400W = 0.4 kWp
const PV_MODULE_AREA = 1.85; // 1 PV Module = 1,85m²

const sumZonesSquareMeter = (zones) => {
    const sum = zones.reduce((sum, zone) => sum + (zone.SquareMeter || 0), 0);
    return parseFloat(sum.toFixed(2));
}

const sumObstaclesSquareMeter = (obstacles) => {
    const sum = obstacles.reduce((sum, obstacle) => sum + (obstacle.SquareMeter || 0), 0);
    return parseFloat(sum.toFixed(2));
}

const sumSquareMeterUsable = (zones) => {
    const sum = zones.reduce((sum, zone) => sum + (zone.SquareMeterUsable || 0), 0);
    return parseFloat(sum.toFixed(2));
}

const sumTotal = (items) => {
    return items.reduce((sum, value) => sum + value, 0);
}

const privateConsumptionYearly = (houseConsumptionTotal, gridSupplyTotal) => {
    return houseConsumptionTotal - gridSupplyTotal;
}

const privateConsumptionPercentage = (privateConsumptionTotal, solarProductionTotal) => {
    if (privateConsumptionTotal <= 0) {
        return 100;
    }
    if (solarProductionTotal === 0) {
        return 0;
    }
    return ((privateConsumptionTotal / solarProductionTotal) * 100).toFixed(2);
}

const estimatePerformanceRatio = (azimuth, tilt) => {
    let orientationFactor;
    const angle = Math.abs(azimuth - 180); // how far from south

    if (angle <= 20) orientationFactor = 1.0;
    else if (angle <= 60) orientationFactor = 0.9;
    else if (angle <= 90) orientationFactor = 0.8;
    else if (angle <= 135) orientationFactor = 0.65;
    else orientationFactor = 0.5; // near north

    let tiltFactor;
    if (tilt >= 20 && tilt <= 35) tiltFactor = 1.0;
    else if (tilt >= 10 && tilt <= 50) tiltFactor = 0.9;
    else tiltFactor = 0.75;

    return orientationFactor * tiltFactor;
};

const getInstalledKWp = (zones) => {   
    const installedKWp = zones.reduce((sum, zone) => {
        const usableArea = zone.SquareMeterUsable || 0;        
        return sum + (Math.floor(usableArea / PV_MODULE_AREA) * PV_MODULE_GEN);
    }, 0);  
    return installedKWp;
};

const annualSavings = (privateConsumptionTotal, energyCostInEUR) => {
    return privateConsumptionTotal * (energyCostInEUR / 100);
};

const annualSavingsOver20Years = (privateConsumptionTotal, energyCostInEUR, energycostTwentyYearIncrease = 3) => {
    const compounded = compoundEnergyCost(energyCostInEUR, energycostTwentyYearIncrease);
    return privateConsumptionTotal * (compounded / 100);
};

const annualFeedInRevenue = (feedInTotal, feedInTariffPerKWh = 8.6) => {
    return feedInTotal * (feedInTariffPerKWh / 100);
};

const incomeOver20Years = (
    privateConsumptionTotal,
    energyCostInEUR,
    feedInTotal,
    energycostTwentyYearIncrease = 3,
    feedInTariffPerKWh = 8.6
) => {
    const savings = annualSavingsOver20Years(privateConsumptionTotal, energyCostInEUR, energycostTwentyYearIncrease);
    const feedInRevenue = annualFeedInRevenue(feedInTotal, feedInTariffPerKWh) * 20; // unchanged
    return savings + feedInRevenue;
};

const compoundEnergyCost = (initialCost, increaseRate, years = 20) => {
    let total = 0;
    for (let year = 0; year < years; year++) {
        total += initialCost * Math.pow(1 + increaseRate / 100, year);
    }
    return total;
};

// const annualSavingsAI360 = () => {

// };

// const annualSavingsAI360Over20Years = () => {

// };

export {
    sumZonesSquareMeter,
    sumObstaclesSquareMeter,
    sumSquareMeterUsable,
    sumTotal,
    privateConsumptionYearly,
    privateConsumptionPercentage,
    estimatePerformanceRatio,    
    getInstalledKWp,
    annualSavings,
    annualSavingsOver20Years,
    annualFeedInRevenue,
    incomeOver20Years,
    // annualSavingsAI360,
    // annualSavingsAI360Over20Years
}
